module.exports = __webpack_public_path__ + "static/media/home.609f14d5.jpg";